import type { ConsignmentSummary, SrfImportParams, SrfImportPreview } from '@/entities/consignments';

/**
 * The `import-srf` endpoint returns the created consignment — same shape as
 * `GET /api/v2/consignments/{id}`.
 */
export type SrfImportResponse = ConsignmentSummary;

export type { SrfImportParams };

/**
 * What the upload hands to the Create page through `location.state` when the
 * import came back as a `200` preview. Shared so both sides agree on the key.
 */
export interface SrfImportPreviewLocationState {
  srfImportPreview?: SrfImportPreview;
}

/** Accepted SRF file extensions (Excel workbook). Enforced by `FileUpload`. */
export const SRF_ALLOWED_EXTENSIONS = ['.xlsx'];

/** Maximum SRF file size — 20 MB. Enforced by `FileUpload`. */
export const SRF_MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;
